import{getTranslate as r}from"../../shared/utils.js";function t(t=(this.isHorizontal()?"x":"y")){const{params:a,rtlTranslate:s,translate:e,$wrapperEl:i}=this;if(a.virtualTranslate)return s?-e:e;if(a.cssMode)return e;let l=r(i[0],t);return s&&(l=-l),l||0}export{t as default};
//# sourceMappingURL=getTranslate.js.map
